import record from './record';
import { Replayer } from './replay';
import { mirror } from './utils';
import * as utils from './utils';
import { pack, unpack } from './packer';

export {
  EventType,
  IncrementalSource,
  MouseInteractions,
  ReplayerEvents,
} from './types';

const { addCustomEvent, takeFullSnapshot } = record;

export { record, addCustomEvent, takeFullSnapshot, Replayer, mirror, utils, pack, unpack };
